/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ErrorKeys } from "../../Constants/ErrorKeys";
import { DataSources } from "../../Constants/DataSources";
import { isStaticBinding, isStaticBindingValid } from "./StaticBindingValidator";
var PlaceholderRelatedDataValidator = /** @class */ (function () {
    function PlaceholderRelatedDataValidator(resourceStringProvider) {
        this.resourceStringProvider = resourceStringProvider;
    }
    PlaceholderRelatedDataValidator.prototype.validate = function (placeholders) {
        return __awaiter(this, void 0, void 0, function () {
            var filteredPlaceholders;
            var _this = this;
            return __generator(this, function (_a) {
                this.missingRelatedDataInputKeys = [];
                filteredPlaceholders = Object.keys(placeholders !== null && placeholders !== void 0 ? placeholders : {}).filter(function (name) { var _a, _b, _c, _d; return ((_b = (_a = placeholders[name]) === null || _a === void 0 ? void 0 : _a.binding) === null || _b === void 0 ? void 0 : _b.inputs) && ((_d = (_c = placeholders[name]) === null || _c === void 0 ? void 0 : _c.binding) === null || _d === void 0 ? void 0 : _d.source) === DataSources.DataverseDataSource; });
                filteredPlaceholders.forEach(function (name) {
                    _this.validateRelatedData(name, placeholders[name].binding, placeholders[name].category);
                });
                return [2 /*return*/, { placeholderValidationData: __spreadArray([], __read(this.missingRelatedDataInputKeys), false) }];
            });
        });
    };
    PlaceholderRelatedDataValidator.prototype.validateRelatedData = function (name, binding, placeholderCategory) {
        if (isStaticBinding(binding) && !isStaticBindingValid(binding)) {
            this.missingRelatedDataInputKeys.push(this.createError(name, ErrorKeys.ErrorMessageStaticBindingPlaceholderValidation));
            return false;
        }
        else {
            return this.validateRelatedDataKeys(name, binding, placeholderCategory);
        }
    };
    PlaceholderRelatedDataValidator.prototype.validateRelatedDataKeys = function (name, binding, placeholderCategory) {
        var _a;
        if (binding) {
            if (binding.source === DataSources.DataverseDataSource && placeholderCategory != "list") {
                var bindingInputParameters = binding.inputs;
                if (bindingInputParameters &&
                    bindingInputParameters.sourceType &&
                    bindingInputParameters.sourcePrimaryIdName &&
                    bindingInputParameters.relationshipName &&
                    bindingInputParameters.relatingRecordName &&
                    bindingInputParameters.relatingRecordId &&
                    ((_a = bindingInputParameters.outputMode) === null || _a === void 0 ? void 0 : _a.value) === "firstOfMany") {
                    // 1:n->1 Placeholder
                    return true;
                }
                if (bindingInputParameters &&
                    bindingInputParameters.recordId &&
                    bindingInputParameters.recordsetType &&
                    bindingInputParameters.sourcePrimaryIdName) {
                    if (bindingInputParameters.recordId.value && !bindingInputParameters.recordId.binding) {
                        // Static record placeholder
                        return true;
                    }
                    else {
                        // Standard related data placeholder
                        return this.validateRelatedDataKeys(name, bindingInputParameters.recordId.binding, placeholderCategory);
                    }
                }
                this.missingRelatedDataInputKeys.push(this.createError(name, ErrorKeys.ErrorMessagePlaceholderValidationDataverseDataSourceInputBindingsMissing));
                return false;
            }
            else {
                return true;
            }
        }
        this.missingRelatedDataInputKeys.push(this.createError(name, ErrorKeys.ErrorMessagePlaceholderValidationDataverseDataSourceInputBindingsMissing));
        return false;
    };
    PlaceholderRelatedDataValidator.prototype.createError = function (name, code) {
        return {
            code: code,
            placeholderKey: name,
            severity: "error",
            message: {
                messageParts: [
                    {
                        type: "string",
                        value: name
                    }
                ],
                messageTemplate: this.resourceStringProvider.getLocalizedString(code)
            }
        };
    };
    return PlaceholderRelatedDataValidator;
}());
export { PlaceholderRelatedDataValidator };
